import isObject from 'lodash/isObject';

import { Constants } from './constants';
const { path, common, tenant } = Constants;

class ElpPathService {
    env = '';
    developmentPath = path.LOCAL_HOST;
    testPath =  path.TEST;
    
    prodPath = {
        api: '',
        app: ''
    };

    basePath = {
        api: '',
        app: ''
    };

    constructor(){
        this.env = process.env.NODE_ENV;
        this.setProdBasePath();
        this.setBasePath();
    }

    /**
     * @param {{ api: string, app: string }} [pathObj] - API and Redirect App url references (optional)
     */
    setProdBasePath(pathObj){
        if(isObject(pathObj)){
            this.prodPath = pathObj;
            return;
        }

        const fullHost = window.location.host;
        const domain = fullHost.split('.')[0];

        // Check if this is a gov cloud domain (elp.egov.com)
        const isGovCloud = fullHost.includes('elp.egov.com');

        // Look up from the appropriate path configuration
        let basePath = isGovCloud ? path.GOV_CLOUD_PATHS[domain] : path[domain];

        if(!basePath){
            // Handles the case you ran a prod build locally
            this.prodPath = domain.includes('localhost') ? this.developmentPath : path.RLP_PROD;
        } else {
            this.prodPath = basePath;
        }
    }

     /**
     * @param {{ api: string, app: string }} [pathObj] - API and Redirect App url references (optional)
     */
    setBasePath(pathObj){
        if(isObject(pathObj)){
            this.basePath = pathObj;
            return;
        }

        const { DEV_ENV, TEST_ENV, PROD_ENV } = common;
        switch(this.env){
            case DEV_ENV:
                this.basePath = this.developmentPath;
                break;
            case TEST_ENV:
                this.basePath = this.testPath;
                this.prodPath = this.testPath;
                break;
            case PROD_ENV:
                if(!this.prodPath.api.length){
                    this.setProdBasePath();
                }

                this.basePath = this.prodPath;
                break;
            default:
                this.basePath = this.developmentPath;
        }
    }

    /**
     * @returns {string} Tenant name derived from current Path
     */
    getTenantFromPath() {
        const domain = window.location.host.split('.')[0];
        //TODO: Pick sane default when we know more
        return tenant.NAME[domain] ? tenant.NAME[domain] : tenant.NAME[tenant.ENV.ILLINOIS.DEV]; 
    }

    /**
     * 
     * @param {string} mspTenantId - mspTenantId from tenant api response
     * @returns {string} url to the create account page of RLP
     */
    getConstituentCreateAcctPath(mspTenantId) {
        const createAcctPath = path.CONSTITUENT_CREATE_ACCOUNT.replace('{mspTenantId}', mspTenantId);

        return this.basePath.app + createAcctPath;
    }

    /**
     *
     * @param {string} mspTenantId - mspTenantId from tenant api response
     * @returns {string} url to the create account page of RLP
     */
    getConstituentVerifyAcctPath(mspTenantId) {
        const verifyAcctPath = path.CONSTITUENT_VERIFY_ACCOUNT.replace('{mspTenantId}', mspTenantId);

        return this.basePath.app + verifyAcctPath;
    }

    /**
     *
     * @param {string} mspTenantId - mspTenantId from tenant api response
     * @returns {string} url to the for username page of RLP
     */
    getConstituentForgotUsernamePath(mspTenantId) {
        const forgotUsernamePath = path.CONSTITUENT_FORGOT_USERNAME.replace('{mspTenantId}', mspTenantId);

        return this.basePath.app + forgotUsernamePath;
    }

    /**
     * @returns {string} url to rlp sign in path for cognito redirect
     */
    getConstituentSignInPath(){
        return this.basePath.app + path.CONSTITUENT_REDIRECT_SIGN_IN;
    }

    /**
     * @returns {string} url to rlp sign out path for cognito redirect
     */
    getConstituentSignOutPath(){
        return this.basePath.app + path.CONSTITUENT_REDIRECT_SIGN_OUT;
    }

    /**
     * 
     * @param {string} mspTenantId - mspTenantId from tenant api response
     * @returns {string} url to the RLP agency login page
     */
    getAgencyLoginPath(mspTenantId) {
        const agencyLoginPath = path.AGENCY_LOGIN.replace('{mspTenantId}', mspTenantId);

        return this.basePath.app + agencyLoginPath;
    }

    /**
     * 
     * @param {string} vanityUrl - url from the vanityUrl property of an AFQ from the AFQ api response
     * @returns {string} url to an active application on RLP
     */
    getApplicationPath(vanityUrl) {
        const applicationPath = path.APPLICATION.replace('{vanityUrl}', vanityUrl);

        return this.basePath.app + applicationPath;
    }
}

export const ElpPathServiceClass = ElpPathService;
export default new ElpPathService();



// WEBPACK FOOTER //
// ./src/common/elpPathService.js